
import { Cell, CellGroup } from 'vant'
import { checkBrowser } from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';
// import {jsSdk} from '../../../assets/libs/loadjs'

export default {
  name: 'home',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data () {
    return {
      nowImei: $cookies.get('imei'),
    }
  },
  methods: {
    // 切换设备
    toChangeDevPageFn () {
      this.$router.push('/changeDev')
    },
    // 确认提示
    wxUnboundFn () {
      this.$dialog.confirm({
        title: '',
        message: '你确定要解除微信、手机号与设备之间的绑定关系吗？'
      }).then(() => {
        this.wxUnboundSubmitFn();
      }).catch(() => {
        // on cancel
      });
    },
    wxUnboundSubmitFn () {
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '解绑中...'
      });
      this.$axios.post('/v3/u/user/unbindVehicle')
        .then((response)=>{
          this.$toast.clear();
          if (response.data.ret === 0) {
            this.$dialog({
              message: '解绑成功'
            }).then(() => {
              this.$cookies.set('imei', "");
              if (checkBrowser.isWx()) {
                // 方法一
                WeixinJSBridge.call('closeWindow');
                // 方法二
                // wx.closeWindow();
              } else {
                window.location.href = 'about:blank';
                window.close();
              }
            })
          } else {
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '解绑失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          this.$toast.clear();
          errorModal(error, 521);
        })
    }
  },
  created () {
    // 调用微信SDK
    // jsSdk(this.$store.state.customer, ['closeWindow']).then(function(){
    //   console.log('ready....');
    // });
  }
}
